import React from 'react';
import './CancellationPopup.css';
import { Link } from 'react-router-dom';

function CancellationPopup({ onClose, onCancel }) {
  return (
    <div className="popup-overlay" role="dialog" aria-modal="true" aria-labelledby="appt-title">
      <div className="popup-container" role="document">
        <button className="close-btn" onClick={onClose} aria-label="Close appointment dialog">×</button>
        <h2 id="appt-title">Appointment Center – Graystone Construction &amp; Calimesa Turf Center</h2>
        <p>
          Choose how you’d like to meet with our team for your turf or construction project. For urgent scheduling,
          same-day questions, or help with an existing job, please call or text our main line at{' '}
          <a href="tel:+16197611113">+1 (619) 761-1113</a>.
        </p>
        <div className="popup-actions">
          <a
            className="redirect-btn virtual-btn"
            href="https://graystonecalimesaappointments.odoo.com/book/dbc0cc14"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book Virtual Appointment (Odoo)
          </a>

          <a
            className="redirect-btn physical-btn"
            href="https://graystonecalimesaappointments.odoo.com/book/0f9ae7db"
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
          >
            On‑Site Visit / Turf Yard Appointment (Calimesa Yard)
          </a>

          <Link className="redirect-btn terms-btn" to="/terms" onClick={onClose}>
            View Terms
          </Link>
        </div>
      </div>
    </div>
  );
}

export default CancellationPopup;